import { Paper, Stack, Typography } from '@mui/material'
import { RadioOffIcon, RadioOnIcon, useMinimalsTheme } from '@tom-ui/ui'
interface Props {
  selectedValue?: boolean
  value: boolean
  title: string
  subTitle?: string
  icon?: React.ReactNode
  hasError?: boolean
  dataCy?: string

  onChange: () => void
}
export const RadioButton = ({
  selectedValue,
  value,
  title,
  subTitle,
  icon,
  hasError,
  dataCy,
  onChange,
}: Props) => {
  const theme = useMinimalsTheme()

  const isSelected = value === selectedValue

  const handleClick = () => {
    onChange()
  }

  return (
    <Paper
      variant='outlined'
      sx={{
        backgroundColor: isSelected ? theme.palette.primary.lighter : 'transparent',
        width: '100%',
        cursor: 'pointer',
        padding: theme.customSpacing.m,
        marginBottom: 2,
      }}
      onClick={handleClick}
      data-cy={dataCy}
    >
      <Stack direction='row' alignItems='center' gap={theme.customSpacing.m}>
        {isSelected ? <RadioOnIcon color='primary' /> : <RadioOffIcon />}
        {icon}
        <Stack>
          <Typography variant='subtitle2'>{title}</Typography>
          {subTitle && <Typography variant='body2'>{subTitle}</Typography>}
        </Stack>
      </Stack>
    </Paper>
  )
}
